<template>
  <div class="diallingCodeSelection">
    <span class="diallingCode" @click="show">+{{modelValue}}</span>
    <div class="diallingCodeMask" v-show="showMask" @click.stop.prevent>
      <div class="placeholder" @click="hide"></div>
      <div class="codeListWrapper">
        <div class="blank"></div>
        <div class="listItem" :class="{active: item.active}" v-for="item of listData" @click="onValueChange(item)" :key="item.label">{{item.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {countriesData} from './data.js'

const options = countriesData.map(item => {
  return {
    label: item.nameCN + ' +' + item.dialCode,
    value: item.dialCode,
    active: item.dialCode == '86'
  }
})
export default {
  props: {
    modelValue: {
      default: '86'
    }
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  data(){
    return {
      diallingCode: this.modelValue,
      listData: options,
      showMask: false
    }
  },
  methods: {
    show(){
      this.showMask = true
    },
    hide(){
      this.showMask = false
    },
    onValueChange(data){
      this.listData.forEach(item => {
        if(item.active){
          item.active = false
        }
        if(item.label == data.label){
          item.active = true
        }
      })
      this.$emit('update:modelValue', data.value)
      this.hide()
    }
  }
}

</script>

<style scoped>
.diallingCodeSelection{
  position: relative;
  color: rgba(51, 51, 51, 1);
  cursor: pointer;
  white-space: nowrap;
}
.diallingCode{
  margin-left: 1.1rem;
  margin-right: .95rem;
  font-weight: 600;
  padding: 0 3px;
}
.diallingCode:after{
  content: '';
  display: inline-block;
  border-top: 5px solid rgba(51, 51, 51, 1);
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: none;
  position: relative;
  top: -2px;
  margin-left: 2px;
}

.diallingCodeMask{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #1d1d1dc9;
  z-index: 1;
}
.placeholder{
  height: 80px;
  flex-shrink: 0;
}

.codeListWrapper{
  position: relative;
  flex: 1;
  overflow: auto;
  background-color: #fff;
  font-weight: 500;
  border-radius: 10px 10px 0 0;
}
.blank{
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 10px;
  background-color: #fff;
  border-radius: 10px 10px 0 0;
}
.listItem{
  margin: 0 15px;
  padding: 10px 0;
  border-bottom: 1px solid rgb(177 175 175 / 10%);
}
.listItem:last-child{
  border-bottom: none;
}

.active{
  font-weight: 600;
}
</style>
